import {FC} from 'react';

import {DashboardSummary} from 'store/models/dashboard';
import {formatCurrency} from '../utils';
import styles from '../Dashboard.module.scss';
import {useChartColors} from '../useChartColors';

interface Props {
  summary?: DashboardSummary;
  isLoading: boolean;
}

// accent: null — берём цвет из темы (синий отличается в светлой/тёмной)
const CARDS: {
  key: keyof DashboardSummary;
  label: string;
  accent: string | null;
}[] = [
  {key: 'totalRevenue', label: 'Total Revenue', accent: null},
  {key: 'refunds', label: 'Refunds', accent: '#F97316'},
  {key: 'discounts', label: 'Discounts', accent: '#EC4899'},
  {key: 'tax', label: 'Tax', accent: '#22C55E'},
];

const KpiCards: FC<Props> = ({summary, isLoading}) => {
  const chartColors = useChartColors();

  return (
    <div className={styles.kpiGrid}>
      {CARDS.map((card) => (
        <div key={card.key} className={styles.kpiCard}>
          <span className={styles.kpiLabel}>{card.label}</span>
          <span
            className={styles.kpiValue}
            style={{color: card.accent ?? chartColors.kpiPrimary}}
          >
            {isLoading
              ? '—'
              : formatCurrency(summary?.[card.key] as number | undefined)}
          </span>
        </div>
      ))}
    </div>
  );
};

export default KpiCards;
